import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import baseSettingSagas from './settings/base_setting/saga';
import profileSaga from './settings/profile/saga';
import mukebSaga from './mukeb/saga';
import benefactorSaga from './benefactor/saga';
import userSaga from './users/saga';
import pollSaga from './poll/saga';
import axeSaga from './axe/saga';
import plateSaga from './plate/saga';
import mapPlateSaga from './mapPlate/saga';

export default function* rootSaga() {
  yield all([
    authSagas(),
    baseSettingSagas(),
    profileSaga(),
    mukebSaga(),
    benefactorSaga(),
    userSaga(),
    pollSaga(),
    axeSaga(),
    plateSaga(),
    mapPlateSaga(),
  ]);
}
